import React, { useContext, useEffect, useState } from 'react';
import CheckOutPayment from '../Components/CheckOut/CheckOutPayment';
import { Link, useNavigate } from 'react-router-dom';
import CheckOutAddress from '../Components/CheckOut/CheckOutAdress';
import axios from 'axios';
import { ConfigContext } from '../Context/ConfigContext';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { formatSlug } from '../Utils/Helper';
import { clearCartItem } from "../Redux/features/Cart/CartSlice"
import Swal from 'sweetalert2';
import { convertCurrency, formatPrice } from '../Utils/GlobalFunction';

const CheckOut = () => {
    const dispatch = useDispatch();
    const { apiURL, apiHeaderJson, currency, currencyValue } = useContext(ConfigContext);
    const [subTotalAmount, setSubTotalAmount] = useState(0);
    const [grandTotalAmount, setGrandTotalAmount] = useState(0);
    const [isApply, setIsApply] = useState(false);
    const [coupon, setCoupon] = useState('');
    const [address, setAddress] = useState(null);
    const cartList = useSelector((state) => state.Cart);
    const navigate = useNavigate()
    const [submiting, setSubmiting] = useState(false);

    const CalculateDiscount = (total, per) => {
        let discountAmount = (per / 100) * total;
        let finalAmount = total - discountAmount;

        return finalAmount;
    }

    const handleApplyCoupon = async () => {
        const headers = apiHeaderJson;
        const body = {
            coupon: coupon,
        };
        try {
            const response = await axios.post(`${apiURL}Order/ApplyCoupon`, body, { headers });

            if (response.data.success) {
                const discount = response.data.discount;
                if (discount) {
                    const newSubTotal = CalculateDiscount(subTotalAmount, discount);
                    setGrandTotalAmount(newSubTotal);
                    setIsApply(true);
                    setCoupon("")
                }
            } else {
                toast.success(response.data.message, {
                    position: "bottom-center",
                })
                setCoupon("")
            }

        } catch (error) {
            console.error("Error applying coupon:", error);
        }
    };


    const convertCardCurrency = () => {
        return cartList.map(item => {
            const convertedMrp = convertCurrency(
                item.product_variant_mrp_price,
                item.selected_currency,
                currencyValue,
                true
            );
            const convertedSale = convertCurrency(
                item.product_variant_sale_price,
                item.selected_currency,
                currencyValue,
                true
            );

            return {
                ...item,
                product_variant_mrp_price: convertedMrp,
                product_variant_sale_price: convertedSale,
                original_currency: item.selected_currency,
                converted_currency: currencyValue,
            };
        });
    };

    const calculatesubTotalAmount = () => {
        const subTotal = cartList.reduce((acc, cur) => {
            const convertedPrice = convertCurrency(
                cur.product_variant_sale_price,
                cur.selected_currency,
                currencyValue
            );
            return acc + cur.quantity * convertedPrice;
        }, 0);
        setSubTotalAmount(subTotal);
        setGrandTotalAmount(subTotal);
    };

    const handlePlaceOrder = (paymentInfo) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to place an order!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, place order!"
        }).then((result) => {
            if (result.isConfirmed) {
                (async () => {
                    setSubmiting(true);
                    const headers = apiHeaderJson;
                    const newCartList = convertCardCurrency();
                    setSubmiting(false);

                    const body = {
                        CartInfo: newCartList,
                        customer_address_id: address,
                        order_sub_total: subTotalAmount,
                        order_grand_total: grandTotalAmount,
                        order_payment_method: paymentInfo?.order_payment_method,
                        order_currency: paymentInfo?.order_currency,
                    };

                    try {

                        const response = await axios.post(`${apiURL}Order/PlaceAndOrder`, body, { headers });
                        if (response.data.success) {
                            toast.success(response.data.message, {
                                position: "bottom-center",
                            });
                            setSubmiting(false);
                            if (response.data.order_id) {
                                setTimeout(() => {
                                    navigate(`/Invoice/${response.data.order_id}`);
                                    dispatch(clearCartItem());
                                }, 1000);
                            }
                        }
                    } catch (error) {
                        setSubmiting(false);
                        console.error("Error placing your order:", error);
                    }
                })();
            }
        });
    };

    useEffect(() => {
        calculatesubTotalAmount();
        document.title = 'StoneSkill | Checkout'
    }, [cartList]);


    const getStarPercent = (rating) => {
        return (rating / 5) * 100;
    };

    return (
        <>
            <ToastContainer />
            <main className="main">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                            <span /> Shop
                            <span /> Checkout
                        </div>
                    </div>
                </div>
                <div className="container mb-80 mt-50">
                    <div className="row">
                        <div className="col-lg-8 mb-40">
                            <h1 className="heading-2 mb-10">Checkout</h1>
                        </div>
                        <div className="col-lg-4 mb-40">
                            {/* <form method="post" className="apply-coupon" onSubmit={(e) => { e.preventDefault(); handleApplyCoupon(); }}>
                                <input
                                    type="text"
                                    placeholder="Enter Coupon Code..."
                                    value={coupon}
                                    onChange={(e) => setCoupon(e.target.value)}
                                />
                                <button className="btn btn-md" disabled={isApply} name="login">Apply Coupon</button>
                            </form> */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className='container'>
                                <div className="row">
                                    <CheckOutAddress setAddress={setAddress} />
                                    <CheckOutPayment handlePlaceOrder={handlePlaceOrder} submiting={submiting} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="border p-40 cart-totals ml-30 mb-50">
                                <div className="d-flex align-items-end justify-content-between mb-30">
                                    <h4>Your Order</h4>
                                    <h6 className="">Subtotal : {formatPrice(subTotalAmount, currencyValue)} </h6>
                                </div>
                                <div className="divider-2 mb-30" />
                                <div className="table-responsive order_table checkout">
                                    <table className="table no-border">
                                        <tbody>
                                            {
                                                cartList.length && cartList.map((item) => {
                                                    return (
                                                        <tr key={item.product_id}>
                                                            <td className="image product-thumbnail"><img src={item.product_image_url} alt={item.product_title} /></td>
                                                            <td>
                                                                <h6 className="w-160 mb-5"><Link to={`/ProductDetails/${formatSlug(item.product_title)}=${item.product_id}`} className="text-heading">{item.product_title}</Link></h6>
                                                                <div className="product-rate-cover d-flex align-items-center justify-content-start">
                                                                    <div className="product-rate d-inline-block me-2">
                                                                        <div className="product-rating" style={{ width: getStarPercent(item?.average_rating) + '%' }} />
                                                                    </div>
                                                                    <span className="font-small text-muted">{item?.average_rating}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h6 className="text-muted pl-20 pr-20">{item.quantity}</h6>
                                                            </td>
                                                            <td>
                                                                {/* <h4 className="text-brand">{currency} {item.quantity * item.product_variant_sale_price}</h4> */}
                                                                <h4 className="text-brand">{formatPrice(item.quantity * item.product_variant_sale_price, item.selected_currency)}</h4>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex align-items-end justify-content-between mt-3">
                                    <h5>Your Grand Total</h5>
                                    <h6 className="">Grand Total : {formatPrice(grandTotalAmount, currencyValue)} </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default CheckOut;